import { Form, Input, DatePicker, Select, Upload, Avatar } from "antd";
import ImgCrop from 'antd-img-crop';
import LoadableButton from "../../../components/buttons/LoadableButton";
import Lock from "../../../assets/auth/Lock";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setloggedIn, setUserDetails } from "../../../store/Slices/userSlice";
import { ChangePasswordApi, ForgetOtp2FAApi, GetUserApi, LogoutApi, Request2faChangeApi, UpdateUserApi } from "../../../api/request/users";
import toast from "react-hot-toast";
import { GetAllCountryApi } from "../../../api/request/common";
import dayjs from "dayjs";
import { removeCookies } from "../../../services/Cookies";
import ModalComponent from "../../../components/modals/ModalComponent";
import { IpProvider } from "../../../services/IpProvider";
import { CameraOutlined } from '@ant-design/icons';
import { handleApiError } from "../../../utils/handleApiError";

export default function ChangePasswordMobile() {

    const [form] = Form.useForm();
    const [updateForm] = Form.useForm();
    const [formotp] = Form.useForm()

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userDetails } = useSelector((state) => state.user);

    const [user, setUser] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingProfileUpdate, setIsLoadingProfileUpdate] = useState(false);
    const [isOpen2FAModal, setIsOpen2FAModal] = useState(false);
    const [countries, setCountries] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [FormData, setFormData] = useState({ email: "" });
    const [loading, setLoading] = useState(false);
    const [timer, setTimer] = useState(0);
    const [ipAddress, setIpAddress] = useState('');
    const [verifyWithOpt, setVerifyWithOpt] = useState(() => {
        const stored = localStorage.getItem("verifyWithOpt");
        return stored ? JSON.parse(stored) : false;
    });

    const getUser = async () => {
        try {
            const { data } = await GetUserApi(userDetails?._id);
            setUser(data?.data);
            updateForm.setFieldsValue({
                FirstName: data?.data?.firstName,
                LastName: data?.data?.lastName,
                PhoneNo: data?.data?.phoneNo,
                ProfileImage: data?.data?.profileImage,
                DOB: data?.data?.dob ? dayjs(data?.data?.dob) : '',
                ExpAsIb: data?.data?.expAsIb,
                City: data?.data?.city,
            });
            dispatch(setUserDetails({ ...userDetails, profileImage: data?.data?.profileImage }));
        } catch (error) {
        }
    }

    const getContriens = async () => {
        try {
            const { data } = await GetAllCountryApi();
            if (data?.success) {
                setCountries(
                    data?.data?.map((item) => ({
                        ...item,
                        value: item?.id,
                        label: item?.countryName,
                    }))
                );
            }
        } catch (error) { }
    };

    const filterOption = (input, option) => {
        return (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
    };

    const beforeUpload = (file) => {
        const isAllowedType =
            file.type === "image/jpeg" ||
            file.type === "image/jpg" ||
            file.type === "image/png";
        if (!isAllowedType) {
            toast.error("You can only upload JPG/JPEG/PNG files!");
            return Upload.LIST_IGNORE;
        }
        const isLt800K = file.size / 1024 < 800;
        if (!isLt800K) {
            toast.error("Image must be smaller than 800KB!");
            return Upload.LIST_IGNORE;
        }
        return true;
    };

    const handleSubmit = async (values) => {
        const { oldPassword, newPassword, confirmPassword } = values;
        if (newPassword !== confirmPassword) {
            toast.error("New password and confirm password do not match.");
            return;
        }
        const params = {
            id: userDetails?._id,
            oldPassword,
            password: newPassword,
            confirmPassword,
        };
        try {
            setIsLoading(true);
            const { data } = await ChangePasswordApi(params);
            if (data?.success) {
                toast.success(data?.message);
                form.resetFields();
                logoutHandler();
            }
            setIsLoading(false);
        } catch (error) {
            handleApiError(error);
            setIsLoading(false);
        }
    };

    const getIpAddress = async () => {
        try {
            const { data } = await IpProvider();
            setIpAddress(data?.ip);
        } catch (error) { }
    }

    const logoutHandler = async () => {
        try {
            setIsLoading(true);
            const { data } = await LogoutApi({ ipAddress });
            if (data?.success) {
            }
            localStorage.clear();
            dispatch(setloggedIn(false));
            removeCookies("token");
            navigate("/");
            setIsLoading(false);
        } catch (err) {
            dispatch(setloggedIn(false));
            removeCookies("token");
            navigate("/");
        }
    };

    const open2FAHandle = async () => {
        setLoading(true);
        const success = await resendOTPHandler(!verifyWithOpt);
        setLoading(false);
        if (success) {
            setFormData({ otp: "" });
            setTimer(120);
            setIsOpen2FAModal(true);
        }
    };

    const resendOTPHandler = async (values) => {
        try {
            const { data } = await Request2faChangeApi(values);
            if (data?.success) {
                toast.success(data?.message);
                return true;
            }
        } catch (err) {
        }
        return false;
    };

    const onChange = (e) => {
        const newValue = e.target ? e.target.value : e;
        setFormData({ ...FormData, otp: newValue });
    };
    const sharedProps = {
        onChange,
    };

    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem("verifyWithOpt"));
        if (stored !== null) {
            setVerifyWithOpt(JSON.parse(stored));
        }
    }, []);

    useEffect(() => {
        getIpAddress();
        getUser();
        getContriens();
    }, []);

    return (
        <div className="mobile-dashboard min-h-screen">
            <div className="grid xl:grid-cols-2 xl:gap-5">
                <p className="text-sm text-gray-600">Change Your Password to Keep Your Account Safe and Secure</p>
                <Form autoComplete="off" onFinish={handleSubmit} form={form} className="mt-5">
                    <div className="">
                        <div className="grid sm:grid-cols-2 gap-4 mb-8">
                            <div>
                                <Form.Item
                                    name="oldPassword"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your current password!",
                                        },
                                    ]}
                                >
                                    <Input.Password
                                        size="large"
                                        placeholder="Current Password"
                                        className="rounded-xl border-[#E2E8F0]"
                                    />
                                </Form.Item>
                            </div>
                            <div>
                                <Form.Item
                                    name="newPassword"
                                    hasFeedback
                                    rules={[
                                        { required: true, message: "Please input your new password!" },
                                        {
                                            validator: (_, value) => {
                                                if (!value) return Promise.resolve();
                                                if (value.length < 8) {
                                                    return Promise.reject(new Error("Password must be at least 8 characters long."));
                                                }
                                                if (!/[a-z]/.test(value)) {
                                                    return Promise.reject(new Error("Password must contain at least one lowercase letter."));
                                                }
                                                if (!/[A-Z]/.test(value)) {
                                                    return Promise.reject(new Error("Password must contain at least one uppercase letter."));
                                                }
                                                if (!/\d/.test(value)) {
                                                    return Promise.reject(new Error("Password must contain at least one number."));
                                                }
                                                if (!/[!@#$%^&*(),.?":{}|<>_\-\\[\];'/`~]/.test(value)) {
                                                    return Promise.reject(new Error("Password must contain at least one special character."));
                                                }
                                                return Promise.resolve();
                                            }
                                        }
                                    ]}
                                >
                                    <Input.Password
                                        size="large"
                                        placeholder="New Password"
                                        className="rounded-xl border-[#E2E8F0]"
                                    />
                                </Form.Item>
                            </div>

                            <div>
                                <Form.Item
                                    dependencies={['newPassword']}
                                    hasFeedback
                                    name="confirmPassword"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please confirm your new password!",
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue('newPassword') === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('The new password that you entered do not match!'));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password
                                        size="large"
                                        placeholder="Confirm Password"
                                        className="rounded-xl border-[#E2E8F0]"
                                    />
                                </Form.Item>
                            </div>
                        </div>

                         <div className="text-base text-gray-600 mb-6">
                            <p className="text-[#2F2B3D] text-lg font-semibold mb-3">Password Requirements:</p>
                            <ul className="list-disc pl-5 space-y-3 text-sm">
                                <li>Minimum 8 characters long - the more, the better</li>
                                <li>At least one lowercase character and uppercase character</li>
                                <li>At least one number and one special character</li>
                            </ul>
                        </div>

                        <div className="mt-6 flex gap-4">
                            <LoadableButton
                                type="submit"
                                className="bg-primary text-sm text-white font-medium px-6 py-4 w-full rounded-lg themeHover duration-500"
                                lable="Change Password"
                                loadingLable="Updating..."
                                isLoading={isLoading}
                                disabled={isLoading}
                            />
                        </div>
                    </div>
                </Form>
            </div>
        </div >
    );
}
